import { render, staticRenderFns } from "./promote-revalidation.vue?vue&type=template&id=3b5dc6ff"
import script from "./promote-revalidation.vue?vue&type=script&lang=ts"
export * from "./promote-revalidation.vue?vue&type=script&lang=ts"
import style0 from "./promote-revalidation.vue?vue&type=style&index=0&id=3b5dc6ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports